import { ref } from 'vue';
export var useDialogVisible = function (defaultVisible) {
    if (defaultVisible === void 0) { defaultVisible = false; }
    var visible = ref(defaultVisible);
    var handleShow = function () {
        visible.value = true;
    };
    var handleHide = function () {
        visible.value = false;
    };
    return {
        visible: visible,
        handleShow: handleShow,
        handleHide: handleHide,
    };
};
